import React, { Component } from 'react'
import styled from 'styled-components'

const Box = styled.div`
  width: calc(33% - 0.75rem);
  margin: 1.5rem 0 0 0;
  display: flex;
  &:first-child, &:nth-child(2), &:nth-child(3) {
    margin-top: 0;
  }
  @media (max-width: 600px) {
    width: 100%;
    &:nth-child(2), &:nth-child(3) {
      margin-top: 1.5rem;
    }
  }
`

export default class ThirdCell extends Component {
  render() {
    return <Box {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/Grid/ThirdCell.js